import { useConstructorContext } from "../../../shared/context/constructor.js";
import "react";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/shared";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const props = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { layout, widgets } = useConstructorContext();
  return {
    ...props,
    layout,
    widgets
  };
};
export {
  useContainer
};
